<template>
  <div id="app" class="bg-background font-cafetera">
    <div v-if="loading" class="min-h-screen grid grid-cols-1 gap-1 place-items-center">
      <Loading/>
    </div>
    <div v-else>
      <div v-if="errorLogin" class="min-h-screen grid grid-cols-1 gap-1 place-items-center text-2xl text-center">
        {{ errorLoginText }}
      </div>
      <div v-else>
        <router-view
          :toBasketFunc="toBasketFunc"
          :payFunc="payFunc"
        />
      </div>
    </div>

		<div :hidden="!$store.getters.snackbar.show" class="absolute top-0 w-full place-items-center">
			<div class="bg-error text-white rounded-lg p-2 m-3 w-auto flex">
				<span class="flex-grow">{{ $store.getters.snackbar.text }}</span>
				<button @click="$store.commit('hideSnackbar')">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
						<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
			</div>
		</div>

    <button 
      v-if="$store.getters.mb_show"
      class="sticky text-white h-16 bottom-0 w-full main-button"
      @click="mainButtonClick"
    >
      <SmallLoading v-if="$store.getters.mb_loading"/>
      <div v-else>
        {{ $store.getters.mb_text }}
      </div>
    </button>
  </div>
</template>

<script>
import Loading from '@/components/ui/Loading'
import SmallLoading from '@/components/ui/SmallLoading'

export default {
  data: () => ({
    loading: true,
		errorLogin: false,
		errorLoginText: ''
  }),
  
  async mounted() {
    this.loading = true
		// window.Telegram.WebApp.backgroundColor = '#F7EDE2'
		// window.Telegram.WebApp.themeParams.button_color = '#005127'
    try {
      if (Object.keys(window.WebApp.initDataUnsafe).length === 0) {
				this.errorLoginText = 'Вход можно выполнить только через бота Max.'
				this.errorLogin = true
      } else if (window.WebApp.initDataUnsafe.start_param === undefined) {
				this.errorLoginText = 'Для открытия приложения используйте кнопку "Меню" из сообщения бота.'
				this.errorLogin = true
      } else {
        const [hash, chatId] = window.WebApp.initDataUnsafe.start_param.split("_")
				await this.$store.dispatch('tryGuestLoginFromTg', {chatId, hash})
      }
		} catch (e) {
			console.log(e.response)
			this.errorLoginText = `Ошибка авторизации: ${e.response.data.message}`
			this.errorLogin = true
		} 
		
		try {
			await this.$store.dispatch('checkRestaurantOpen')
		} catch (e) {
			this.errorLogin = true
			this.errorLoginText = e.response.data.message
		} finally {
			this.loading = false
		}
	},

  // Данные методы вынесены в одно место с той целью, чтобы
  // при их удалении из кнопки тг они действительно удалялись
  methods: {
		toBasketFunc() {
			this.$router.push('/basket')
		},
		async payFunc() {
			if (this.$store.getters.selectedSlot == undefined) {
				this.$store.commit('showSnackbar', 'Выберите слот времени')
				return
			}

			if (await this.$store.dispatch('getEnableDeliveryAreas') && window.location.pathname != '/delivery-area') {
				this.$router.push('/delivery-area')
				return
			}

			if (window.location.pathname == '/delivery-area' && this.$store.getters.selectedDeliveryArea == null) {
				this.$store.commit('showSnackbar', 'Выберите зону доставки')
				return
			} 

      this.$store.commit('mb_showLoading')
			// window.Telegram.WebApp.MainButton.showProgress()
			try {
				await this.$store.dispatch('uploadBasket')
				// window.Telegram.WebApp.close()
        this.$router.push('/order-created')
			} finally {
        this.$store.commit('mb_hideLoading')
				// window.Telegram.WebApp.MainButton.hideProgress()
			}
		},
    async mainButtonClick() {
      if (this.$store.getters.mb_func !== null) {
        await this.$store.getters.mb_func()
      }
    }
	},

  components: { Loading, SmallLoading }
}
</script>

<style>
.main-button {
  background-color: #005127;
}
</style>
